import React, { useCallback, useState, useLayoutEffect, useMemo } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "../header/FilterReport"
import styles from "../style.module.css"
import { Tag } from "rsuite"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../../utils/axios.service";
import _ from "lodash"
import async from "async"
import { Line } from '@ant-design/plots';
import { Table, Spin } from "antd"
import getDates from "../../constant/getDates"
import { DataGrid } from '@mui/x-data-grid';
import "../scss/report.scss"
import StorageService from "../../../utils/storage.service";
import { Tooltip } from "antd";

const configChart = (data, convertCurrency) => {  
    var config = {
        data: data,
        xField: "date",
        yField: "value",
        seriesField: "type",
        height: 520,
        xAxis: {
          title: {
            text: "Bán Hàng",
            position: "end",
            offset: 0,
            spacing: 8,
            style: {
              fontSize: 13,
              fontWeight: 900,
              textAlign: "start"
            }
          },
          line: {
            style: {
              stroke: "black"
            }
          },
          tickLine: {
            style: {
              stroke: "black"
            }
          },
          label: {
            autoRotate: true,
            style: {
              fill: "black",
            //   fontSize: 10
            },
            formatter: (text) => {
              const oldLabel = text;
              const labelLength = oldLabel.replace(/[^x00-xff]/g, "xx").length;
              let newLabel = "";
              if (labelLength > 12) {
                let strLen = 0;
                let firstStr = "";
                let lastStr = "";
                for (let i = 0; i < labelLength; i++) {
                  if (oldLabel.charCodeAt(i) > 128) {
                    strLen += 2;
                  } else {
                    strLen++;
                  }
                  if (strLen <= 12) {
                    firstStr += oldLabel.charAt(i);
                  } else {
                    lastStr += oldLabel.charAt(i);
                  }
                }
                newLabel = `${firstStr}\n${lastStr}`;
              } else {
                newLabel = oldLabel;
              }
              return newLabel;
            }
          }
        },
        yAxis: {
          line: {
            style: {
              lineWidth: 2
            }
          },
          label: {
            style: {
              fill: "black"
            },
            offset: 15,
            formatter: (text) => _.round(_.divide(text, 1), 2).toLocaleString()
          }
        },
        color: ["#673ab7", "#2196f3", "#4caf50"],
        legend: {
          position: "right",
          marker: {
            symbol: "square"
          },
          itemName: {
            formatter: (text, item, index) => {
    
              return '';
            }
          }
        },
        point: [{
            size: 3,
            shape: 'circle',
            style: {
                fill: 'blue',
                stroke: '#673ab7',
                lineWidth: 2,
            },
        }, {
            size: 3,
            shape: 'circle',
            style: {
                fill: 'blue',
                stroke: '#2196f3',
                lineWidth: 2,
            },
        },
        {
            size: 3,
            shape: 'circle',
            style: {
                fill: 'blue',
                stroke: '#4caf50',
                lineWidth: 2,
            },
        }],
        tooltip: {
            customContent: (count, data) => {
                let fileHtml = ''
                let title = ''
                for(let item of data) {
                    title = item.title
                    let name = item.name
                    let value = item.value
                    if (name != "Đơn hàng mới") {
                        value = convertCurrency(Number(item.value))
                    }
                    fileHtml += '<li class="g2-tooltip-list-item">'
                    fileHtml += '<span class="g2-tooltip-marker" style="background: '+item.color+'; width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 8px;">' + '</span>'
                    fileHtml += '<span class="g2-tooltip-name" style="color: '+item.color+';">'+item.name + '</span>'
                    fileHtml += '<span class="g2-tooltip-value" style="color: '+item.color+';">'+ value + '</span>'
                    fileHtml += '</li>'
                }
                return `<div class="g2-tooltip-title" style="margin-bottom: 12px; margin-top: 12px; padding-top: 12px; font-weight: bold; font-size: 15px"><p> ${title} </div>
                    <ul class="g2-tooltip-list" style="margin: 0px; list-style-type: none; padding: 12px !important; ">
                        ${fileHtml}
                        </br>
                    </ul>
                </div>`;
            }
        },
      };
    return config
}

const ReportKtvTvDetails = () => {
    const columns = [
        { dataIndex: 'date', title: 'Thời gian', width: 150 , fixed : 'left' },
        {
            dataIndex: 'totalPrice',
            title: 'Doanh số thuần',
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{convertCurrency(data)}</p>
                )
            },
        },
        {
            dataIndex: 'paid',
            title: <Tooltip className="show-tooltip" title='Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ mọi nguồn bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'>
                Tiền đã thu <i className="fas fa-info-circle"></i>
            </Tooltip>,
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
            sorter: {
                compare: (a, b) =>Number(a.paid) - Number(b.paid),
                multiple: 1,
            },
        },
        {
            dataIndex: 'paidNoTax',
            title: <Tooltip className="show-tooltip" title='Tiền đã thu trừ thuế.'>
                Thực thu bán hàng<i className="fas fa-info-circle"></i>
            </Tooltip>,
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
            sorter: {
                compare: (a, b) =>Number(a.paidNoTax) - Number(b.paidNoTax),
                multiple: 1,
            },
        },
        {
            dataIndex: 'countOrderNew',
            title: <Tooltip className="show-tooltip" title='Tổng số đơn hàng các nguồn tư vấn, nếu đơn hàng upsale hai người tư vấn khác nhau thì đơn upsale cũng tính là một đơn mới bạn đầu tiên, đơn thứ hai được tính đơn mới cho người thứ hai. Chỉ được tính khi đơn hàng lần đâu tiên được thanh toán. Không tính đơn nạp tiền'>
                Tổng số hoá đơn  <i className="fas fa-info-circle"></i>
            </Tooltip>,
            width: 170 ,
            align: "center",
            render: (data) => {
                return (
                    <p className="text3">{data}</p>
                )
            },
        },
        
        {
            dataIndex: 'aov',
            title: 'AOV',
            align: "center",
            width: 150 ,
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
        },
        {
            title: 'Thực thu triệt',
            align: "start",
            // width: 200 ,
            render: (data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Thực thu KTV: {convertCurrency(data.paidTriet)}</p>
                        <p className="text2">Tổng đơn KTV: {data.countTriet}</p>
                        <p className="text3">AOV KTV: {convertCurrency(data.aovTriet)}</p>
                    </div>
                )
            },
        },
        {
            title: 'Thực thu da',
            align: "start",
            render: (t,data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Thực thu KTV: {convertCurrency(data.paidDa)}</p>
                        <p className="text2">Tổng đơn KTV: {data.countDa}</p>
                        <p className="text3">AOV KTV: {convertCurrency(data.aovDa)}</p>
                    </div>
                )
            },
        },
        {
            title: 'Thực thu dịch vụ body',
            align: "start",
            render: (data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Thực thu KTV: {convertCurrency(data.paidBody)}</p>
                        <p className="text2">Tổng đơn KTV: {data.countBody}</p>
                        <p className="text3">AOV KTV: {convertCurrency(data.aovBody)}</p>
                    </div>
                )
            },
        },
        {
            title: 'Thực thu khác',
            align: "start",
            render: (t,data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Thực thu KTV: {convertCurrency(data.paidKhac)}</p>
                        <p className="text2">Tổng đơn KTV: {data.countKhac}</p>
                        <p className="text3">AOV KTV: {convertCurrency(data.aovKhac)}</p>
                    </div>
                )
            },
        },
    ];
    var date = new Date();
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(date)),"yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(date), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            [JSON.parse(StorageService.getItem("user_info")).stores[0].id]
        : [parseInt(StorageService.getItem("currentStore"))] )
    const [sortBy, setSortBy] = useState(0)
    const [totalPrice, setTotalPrice] = useState(0)

    const [totalPaid, setTotalPaid] = useState(0)
    const [totalPaidNoTax, setTotalPaidNoTax] = useState(0)
    const [totalOrderNew, setTotalOrderNew] = useState(0)

    const [totalOrderTriet, setTotalOrderTriet] = useState(0)
    const [totalOrderDa, setTotalOrderDa] = useState(0)
    const [totalKhac, setTotalKhac] = useState(0)
    const [totalOrderBody, setTotalOrderBody] = useState(0)

    const [totalPaidBody, setTotalPaidBody] = useState(0)
    const [totalPaidTriet, setTotalPaidTriet] = useState(0)
    const [totalPaidDa, setTotalPaidDa] = useState(0)
    const [totalPaidKhac, setTotalPaidKhac] = useState(0)

    const [totalPaidBodyNoTax, setTotalPaidBodyNoTax] = useState(0)
    const [totalPaidTrietNoTax , setTotalPaidTrietNoTax] = useState(0)
    const [totalPaidDaNoTax, setTotalPaidDaNoTax] = useState(0)
    const [totalPaidKhacNoTax, setTotalPaidKhacNoTax] = useState(0)

    const [ordersByDaysCountBooking, setOrdersByDaysCountBooking] = useState([])
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(true);
    const [isExport, setIsExport] = useState(false)
    
    const [pageSize, setPageSize] = useState(5)
    const [listCategoryIds, setSistCategoryIds] = useState([2, 4, 5, 45, 46, 47])
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [typeBHVV, setTypeBHVV] = useState(0)

    const handleRangeDate = useCallback((sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }, [startDate, endDate])

    const handleStore = useCallback((e) => {
        setStore(e)
    }, [store])

    const handleSortBy = useCallback((e) => {
        setSortBy(e)
    }, [sortBy]);

    useLayoutEffect(() => {
        setLoading(true)
        fetchData(store, endDate, startDate, sortBy, typeBHVV)
    }, [store, endDate, startDate, sortBy, typeBHVV])
    
    const fetchData = async (s, eD, sD, sBy, typeBHVV) => {
        let payload = {
            storeId: s,
            startDate: sD,
            endDate: eD,
            sortBy: sBy,
            typeBHVV: typeBHVV
        }
        const rs = await axiosService(`api/reports/store/work/ktv-tv-details`, "POST", payload)
        if (rs.data.code == 200) {
            const { data } = rs.data
            setTotalPrice(data.totalPrice)
            setTotalPaid(data.totalPaid)
            setTotalPaidNoTax(data.totalPaidNoTax)
            setTotalOrderNew(data.totalOrderNew)

            setTotalOrderTriet(data.totalOrderTriet)
            setTotalOrderDa(data.totalOrderDa)
            setTotalKhac(data.totalKhac)
            setTotalOrderBody(data.totalOrderBody)

            setTotalPaidTriet(data.totalPaidTriet)
            setTotalPaidDa(data.totalPaidDa)
            setTotalPaidKhac(data.totalPaidKhac)
            setTotalPaidBody(data.totalPaidBody)

            setTotalPaidTrietNoTax(data.totalPaidTrietNoTax)
            setTotalPaidDaNoTax(data.totalPaidDaNoTax)
            setTotalPaidKhacNoTax(data.totalPaidKhacNoTax)
            setTotalPaidBodyNoTax(data.totalPaidBodyNoTax)
            
            setRows(data.dataTable)

            let rowsCountBooking = []
            let rowsCountBookingSuccess = []
            let rowsCountBookingService = []
            for (let item of data.dataTable.reverse()) {
                let rowCountBooking = {
                    date: item.date,
                    value: item.paid,
                    type: 'Tiền thực thu'
                }
                let rowCountBookingSuccess = {
                    date: item.date,
                    value: item.countOrderNew,
                    type: 'Đơn hàng mới'
                }
                let rowCountBookingService = {
                    date: item.date,
                    value: item.aov,
                    type: 'Aov'
                }
                rowsCountBooking.push(rowCountBooking)
                rowsCountBookingSuccess.push(rowCountBookingSuccess)
                rowsCountBookingService.push(rowCountBookingService)
            }
            setOrdersByDaysCountBooking([...rowsCountBooking, ...rowsCountBookingSuccess, ...rowsCountBookingService])
            let value = "yyyy-MM-dd"
                if (sortBy === 1) {
                    value = "ww"
                } else if (sortBy === 2) {
                    value = "MM"
                }
            setLoading(false)
        }
    
    }

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const config = useMemo(() => configChart(ordersByDaysCountBooking, convertCurrency), [ordersByDaysCountBooking])
    
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    
    const handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    return (
        <div className={`${styles.background} container-fluid report-page`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                sortBy={sortBy} handleSortBy={handleSortBy}
                title={"Tư vấn cơ sở theo ngày"} type={"daily"}
                typeBHVV={typeBHVV} setTypeBHVV={setTypeBHVV}
                csvData={rows} isExport={isExport}
                handleExportData={handleExportData}
                header={
                    [
                        { label: 'Thời gian', key: "date" },
                        { label: "Số lượng lịch đặt", key: "count_booking" },
                        { label: "Số lượng lịch huỷ", key: "count_close" },
                        { label: "Số lượng lịch thành công", key: "count_success" },
                        { label: "Tỉ lệ huỷ/tổng lịch đặt", key: "proportion" },
                        { label: "Số lượng khách hàng phục vụ", key: "count_customer" },
                        { label: "Lượt dịch vụ", key: "count_service" },
                    ]
                }
                userAdmin={userAdmin}
            />
            <Spin spinning={loading}>
                <Row className="mt-2">
                    <Col xs={12} md={12}>
                        <Row className="h-100">
                            <Col xs={6} md={2}>
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <div className={styles.textTag3}>
                                        <Tooltip title='Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). Từ mọi nguồn của cơ sở.'>
                                            Doanh số thuần <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(totalPrice || 0)}
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col xs={6} md={2}>
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <div className={styles.textTag3}>
                                        <Tooltip title='Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ mọi nguồn (Offline + Online) bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'>
                                            Tổng tiền đã thu <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(totalPaid || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        <Tooltip title='Tổng tiền đã thu trừ VAT'>
                                            Tổng thực thu bán hàng <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(totalPaidNoTax  || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        Số hóa đơn: 
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {totalOrderNew}
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col xs={6} md={2} className="pay_type">                   
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <div className={styles.textTag3}>
                                        Tiền đã thu Triệt
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(totalPaidTriet || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        Thực thu bán hàng Triệt
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(totalPaidTrietNoTax  || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        Số hóa đơn: 
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {totalOrderTriet}
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col xs={6} md={2} className="pay_type">                   
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <div className={styles.textTag3}>
                                        Tiền đã thu Da
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(totalPaidDa || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        Thực thu bán hàng Da
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(totalPaidDaNoTax  || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        Số hóa đơn: 
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {totalOrderDa}
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col xs={6} md={2} className="pay_type">                   
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <div className={styles.textTag3}>
                                        Tiền đã thu Body
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(totalPaidBody || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        Thực thu bán hàng Body
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(totalPaidBodyNoTax || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        Số hóa đơn: 
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {totalOrderBody}
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col xs={6} md={2} className="pay_type">                   
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <div className={styles.textTag3}>
                                        Tiền đã thu Khác
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(totalPaidKhac || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        Thực thu bán hàng Khác
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(totalPaidKhacNoTax || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        Số hóa đơn: 
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {totalKhac}
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mt-2" style={{alignItems: 'end'}}>
                    <Col xs={12} md={5} className="hide-mobile">
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <Line {...config} />
                        </div>
                    </Col>
                    <Col xs={12} md={7}>
                        <div style={{ backgroundColor: "white" }} >
                            <div className="border-bottom mb-1 p-2">
                                <strong className="m-2">Bảng dữ liệu chi tiết</strong>
                            </div>
                            <div style={{ height: 495, width: '100%' }} className="p-2">
                                <Table 
                                    columns={columns} 
                                    dataSource={rows}
                                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['5', '15', '30', '50', '100'] }}
                                    scroll={{ x: columns.length*200, y: 600 }}
                                    onChange={handleChange}
                                    showSorterTooltip={{ title: '' }}
                                    bordered
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div >
    )
}

export default ReportKtvTvDetails